module.exports = __webpack_public_path__ + "img/33342e3d61.42e3d614.png";